import FormComponents from "components/forms/FormComponents";
import { Icon, Modal } from "enums";
import manager from "managers/app";
import { FieldOperationModalProps } from "modals/content/field-operations/types";
import ModalContent from "modals/content/ModalContent";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./FieldOperationsModal.css";

const mapStateToProps = (state:AppState):FieldOperationModalProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		fieldOperations: state.modal[Modal.FIELD_OPERATION],
	};
};

class FieldOperationsModal extends Component<FieldOperationModalProps.Component> {
	render():JSX.Element{
		return (
			<div id={Modal.FIELD_OPERATION} className="modal-wrapper">
				<ModalHeader text="Field Operations" icon={Icon.DUTY} />
				<ModalContent>
					<div className="field-operation-wrapper">
						{this.props.fieldOperations.map((fieldOperation) => {
							return <div key={fieldOperation} className="field-operation-card">
								<h3 className="field-operation-name">{t.t(fieldOperation)}</h3>
							</div>;
						})}
					</div>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
				</ModalFooter>
			</div>
		);
	}
}
export default connect(mapStateToProps)(FieldOperationsModal);
